import { Fragment } from 'react';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { Schema } from '../queries';
import { SchemaForm } from './schema-form';
import { SchemaFormLabel } from './schema-form-label';

interface Props {
  disabled?: boolean;
  schemaId: string;
  schema: Schema;
  path?: string;
}

export function SchemaFormObject({ schema, schemaId, disabled, path = '' }: Props) {
  const isStep = path.startsWith('step_');
  const level = path.split('.').length;

  if (schema.type !== 'object') {
    return null;
  }

  const Wrapper = level > 2 ? Card.InnerContent : Fragment;

  return (
    <ListLayout.Stack>
      <Wrapper>
        <ListLayout.Column>
          {level <= 2 && !isStep && <Card.Separator />}
          <SchemaFormLabel path={path} schema={schema} level={level} schemaId={schemaId} />

          {Object.entries(schema.properties || {}).map(([key, value]) => (
            <SchemaForm
              path={`${path ? `${path}.` : ''}${key}`}
              schemaId={schemaId}
              disabled={disabled}
              schema={value}
              key={key}
            />
          ))}
        </ListLayout.Column>
      </Wrapper>
    </ListLayout.Stack>
  );
}
